import React from 'react';
import Chronometer from '@catalogo/ui-americanas-desktop-chronometer';
import { WrapperOption, ColUI, ColUIFull, ColUIChronometer, TextFreight, TextUI, ShippingMessage } from './styles';
import StoreCard from '../store-card';
import FreightIcon from '../freight-icon';

export const FreightOptions = props => {
  const { freight, store, isLoading } = props;
  const { hasFreightIncentive } = freight;
  const options = freight?.options || [];

  return (
    <>
      {options.map((option, index) => {
        const { id, showChronometer, modalityType, modalityTypeIcon, fmtText, listPrice, price } = option;
        const free = price === 'grátis';
        const showStore = !!store && modalityType?.toUpperCase() === 'RETIRAR';
        const showFreightIncentive = hasFreightIncentive && index === 0 && !free;

        return (
          <React.Fragment key={id}>
            <WrapperOption className="freight-option" $showLastCol={showChronometer || showStore}>
              <ColUI $isLoading={isLoading}>
                <FreightIcon modalityTypeIcon={modalityTypeIcon} />
                <TextFreight className="freight-option-text" dangerouslySetInnerHTML={{ __html: fmtText }} />
              </ColUI>
              <ColUI $hasListPrice={!!listPrice} $isLoading={isLoading}>
                {listPrice && (
                  <TextUI className="freight-option-discount" $isLoading={isLoading}>
                    <s>{listPrice}</s>
                  </TextUI>
                )}
                <TextUI className="freight-option-price" free={free} $isLoading={isLoading}>
                  {price}
                </TextUI>
              </ColUI>
              {showFreightIncentive && (
                <ShippingMessage $isLoading={isLoading}>
                  <strong>frete mais barato</strong>&nbsp;na compra de mais unidades
                </ShippingMessage>
              )}
              {showChronometer && free && (
                <ColUIChronometer $isLoading={isLoading}>
                  <Chronometer option={option} />
                </ColUIChronometer>
              )}
              {showStore && (
                <ColUIFull>
                  <StoreCard store={store} />
                </ColUIFull>
              )}
            </WrapperOption>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default FreightOptions;
